import classNames from 'classnames';
import { Button, Dialog } from '@servicetitan/design-system';
import { injectDependency } from '@servicetitan/react-ioc';
import { Component, FC } from 'react';
import { Confirm, ConfirmationProps } from '@servicetitan/confirm';
import { PlaidIntegrations } from '../utils/plaid-integrations-service';
import { AchModalStore } from '../stores/ach-modal.store';

interface RemoveACHModalProps {
    onRemoveACH(): void;
    buttonText?: string;
    simple?: boolean;
}

export class RemoveACHModal extends Component<RemoveACHModalProps> {
    @injectDependency(PlaidIntegrations)
    declare private plaidIntegrations: PlaidIntegrations;
    @injectDependency(AchModalStore)
    declare private achModalStore: AchModalStore;

    removeBank = async () => {
        this.plaidIntegrations.resetPlaidIntegration();
        this.achModalStore.resetInstance();
        this.props.onRemoveACH();
    };

    render() {
        return (
            <div className={classNames('p-1', 'm-y-half', 'm-x-auto', 'ta-center')}>
                <Confirm onConfirm={this.removeBank} confirmation={DialogConfirmation}>
                    {onClick =>
                        !this.props.simple ? (
                            <Button onClick={onClick}>{this.props.buttonText || 'Cancel'}</Button>
                        ) : (
                            <a onClick={onClick}>{this.props.buttonText || 'Cancel'}</a>
                        )
                    }
                </Confirm>
            </div>
        );
    }
}

const DialogConfirmation: FC<ConfirmationProps> = ({ onConfirm, onCancel }) => (
    <Dialog
        open
        closable
        negative
        onClose={onCancel}
        title="Are you sure you want to cancel ACH integration?"
        onPrimaryActionClick={onConfirm}
        primaryActionName="Confirm"
        onSecondaryActionClick={onCancel}
        secondaryActionName="Cancel"
    />
);
